<template src="./ReclamoInicio.html"></template>

<script>
import {Divider} from "element-ui";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {requesServelMixin} from "@/api/servelApi";
import {requestReclamosMixin} from "@/api/reclamosApi";

export default {
  name: "ReclamoInicio",
  components: {
    [Divider.name]: Divider,
  },
  mixins: [
    requestReclamosMixin,
    NotifyMixin,
    ScreenSizeMixin,
    requesServelMixin
  ],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    validateNoReclamo() {
      this.loading = true
      this.getReclamoValidate()
        .then(response => {
          this.$log.debug('getReclamoValidate', response.data.statusCode)
          if (response.data.statusCode === 200) {
            this.$emit('on-validation', false)
          } else if (response.data.statusCode === 400) {
            this.showError(`Tiene pendiente una solicitud de reclamo.`)
            this.$emit('on-validation', true)
          } else if (response.data.statusCode === 403) {
            this.showError(`No se encuentra vigente en el Registro Electoral.`)
            this.$emit('on-validation', true)
          } else {
            this.showError(`Ocurrió un error inesperado al cargar las validaciones.`)
            this.$emit('on-validation', true)
          }

          this.loading = false
        })
        .catch(err => {
          this.$log.fatal('getReclamoValidate', err.response, err.request)
          this.showError('Ocurrió un error inesperado al cargar las validaciones')

          this.$emit('on-validation', true)
          this.loading = false
        })
    },
  }
}
</script>
